/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import { LISTING_STATUS } from './constants/listingStatus';
import { materializeSelection } from './helpers/applySelection';

export const pinEditLiveSearch = createAction('products/pinEditLiveSearch');
export const clearPinnedSearch = createAction('products/clearPinnedSearch');

export const reducer = (builder) => {
  builder
    .addCase(pinEditLiveSearch, (state, { payload }) => {
      if (!payload) {
        state.ui.pinnedSearch = null;
        return;
      }

      const selectionEntries = Array.isArray(payload.selectionEntries)
        ? payload.selectionEntries
        : [];
      const variantParentById = {};
      selectionEntries.forEach((entry) => {
        if (entry?.type !== 'listingVariant' || !entry._id || !entry.baseProductId) return;
        variantParentById[String(entry._id)] = String(entry.baseProductId);
      });

      state.ui.pinnedSearch = {
        ids: payload.ids || [],
        productLayer: payload.productLayer,
        listingStatus: payload.listingStatus,
        variantParentById,
      };

      if (!selectionEntries.length) return;

      state.ui.selection = materializeSelection(
        selectionEntries.map((entry) => ({
          ...entry,
          listingStatus: LISTING_STATUS.DRAFT,
        })),
        { isComplete: false, source: 'search' },
      );
    })
    .addCase(clearPinnedSearch, (state) => {
      state.ui.pinnedSearch = null;
    });
};
